export default [
  {
    titleKey: 'dashboard',
    title: 'Tổng quan',
    group: 'apps',
    icon: 'dashboard',
    name: 'Dashboard',
    roleId: 1
  },
  {
    titleKey: 'quotes',
    title: 'Khai báo',
    group: 'apps',
    icon: 'request_quote',
    name: 'QuoteList',
    roleId: 64,
    children: [
      { name: 'QuoteDetail', title: 'Chi tiết khai báo', component: 'QuoteDetail' }
    ]
  },
  {
    titleKey: 'deposit',
    title: 'Nạp tiền',
    group: 'apps',
    icon: 'account_balance_wallet',
    name: 'RechargeHistory',
    roleId: 512
  },
  {
    titleKey: 'customers',
    name: 'CustomerList', 
    title: 'Khách hàng', 
    icon: 'account_box',
    name: 'CustomerList', 
    roleId: 2,
    children: [
      { name: 'CustomerDetail', titleKey: 'customer_detail', title: 'Chi tiết khách hàng', component: 'CustomerDetail' }
    ]
  },
  // {
  //   title: 'Tracking',
  //   group: 'apps',
  //   icon: 'gps_fixed',
  //   name: 'Tracking',
  //   roleId: 2048
  // },
  {
    titleKey: 'tracking_code',
    title: 'Mã bill',
    group: 'ma-bill',
    icon: 'inventory',
    name: 'ProductList',
    roleId: 32,
    items: [
      { titleKey: 'all', title: 'Tất cả', name: 'ProductList', component: 'ProductList' },
      { titleKey: 'import_tq', title: 'Nhập kho TQ', name: 'ProductList_TQ', component: 'ProductList_TQ' },
      { titleKey: 'waiting_for_truck', title: 'Chờ xếp xe', name: 'ProductList_Wait', component: 'ProductList_Wait' },
      { titleKey: 'on_the_way', title: 'Đã xếp xe', name: 'ProductList_OnWay', component: 'ProductList_OnWay' },
      // { titleKey: 'processing_tq', title: 'Chờ thông quan TQ', name: 'ProductList_Processing_TQ', component: 'ProductList_Processing_TQ' },
      { titleKey: 'check', title: 'Kiểm hóa', name: 'ProductList_Check', component: 'ProductList_Check' },
      { titleKey: 'processing_vn', title: 'Chờ thông quan VN', name: 'ProductList_Processing_VN', component: 'ProductList_Processing_VN' },
      { titleKey: 'import_vn', title: 'Nhập kho VN', name: 'ProductList_VN', component: 'ProductList_VN' },
      { titleKey: 'exported', title: 'Đã xuất kho', name: 'ProductList_Ex', component: 'ProductList_Ex' },
      { titleKey: 'no_owner', title: 'Hàng không tên', name: 'ProductNoneOwnerList', component: 'ProductNoneOwnerList' },
    ]
  },
  {
    titleKey: 'product_inventory',
    title: 'Hàng tồn',
    group: 'hang-ton',
    icon: 'inventory',
    name: 'ProductListInventory',
    roleId: 64,
    items: [
      { titleKey: 'product_inventory_in_tq', title: 'Tồn kho TQ', name: 'ProductList_In_TQ', component: 'ProductList_In_TQ' },
      { titleKey: 'product_inventory_in_vn', title: 'Tồn kho VN', name: 'ProductList_In_VN', component: 'ProductList_In_VN' },
    ]
  },
  {
    titleKey: 'truck',
    title: 'Xếp xe',
    group: 'apps',
    icon: 'local_shipping',
    name: 'TruckList',
    roleId: 64,
    children: [
      { name: 'TruckDetail', titleKey: 'truck_detail', title: 'Chi tiết xếp xe', component: 'TruckDetail' }
    ]
  },
  {
    titleKey: 'warehouse_export',
    title: 'Xuất kho',
    group: 'apps',
    icon: 'receipt',
    name: 'BillList',
    roleId: 4096,
    children: [
      { name: 'BillDetail', titleKey: 'bill_detail', title: 'Chi tiết xuất kho', component: 'BillDetail' }
    ]
  },
  // {
  //   title: 'Thanh toán',
  //   group: 'apps',
  //   icon: 'attach_money',
  //   name: 'PayOrderList',
  //   roleId: 8
  // },
  // {
  //   title: 'Nhập kho TQ',
  //   group: 'apps',
  //   icon: 'assignment',
  //   name: 'StoreManager',
  //   roleId: 128
  // },
  // {
  //   title: 'Đóng bao TQ',
  //   group: 'apps',
  //   icon: 'archive',
  //   name: 'BigPackage',
  //   roleId: 64
  // },
  {
    titleKey: 'reports',
    title: 'Báo cáo',
    group: 'bao-cao',
    icon: 'speed',
    name: 'Report',
    roleId: 2,
    items: [
      {
        titleKey: 'revenue_report',
        title: 'Doanh thu',
        name: 'bao-cao-doanh-thu',
        component: 'bao-cao-doanh-thu',
        roleId: 1024
      },
      {
        titleKey: 'truck_report',
        title: 'Xe hàng',
        name: 'bao-cao-xe-hang',
        component: 'bao-cao-xe-hang',
        roleId: 1024
      },
      {
        titleKey: 'customer_debt_report',
        title: 'Công nợ khách hàng',
        name: 'bao-cao-cong-no-khach-hang',
        component: 'bao-cao-cong-no-khach-hang',
        roleId: 1024
      },
      {
        titleKey: 'staff_commission_stats',
        title: 'Hoa hồng sale',
        name: 'bao-cao-hoa-hong-sale',
        component: 'bao-cao-hoa-hong-sale',
        roleId: 1024
      }
    ]
  },
  {
    titleKey: 'settings',
    title: 'Cài đặt',
    group: 'cai-dat',
    icon: 'settings',
    name: 'Setting',
    roleId: 256,
    items: [
      {
        titleKey: 'vn_warehouse_config',
        title: 'Kho nhận',
        name: 'StorageList',
        component: 'StorageList'
      },
      {
        titleKey: 'product_type',
        title: 'Loại hàng',
        name: 'ProductTypeList',
        component: 'ProductTypeList'
      },
      {
        titleKey: 'weight_fee',
        title: 'Phí cân',
        name: 'FeeWeightList',
        component: 'FeeWeightList'
      },
      {
        titleKey: 'volume_fee',
        title: 'Phí khối',
        name: 'FeeVolumeList',
        component: 'FeeVolumeList'
      },
      {
        titleKey: 'cost_weight',
        title: 'Giá gốc',
        name: 'CostWeightList',
        component: 'CostWeightList'
      },
      {
        titleKey: 'sale_commission_tier',
        title: 'Cấu hình thưởng sale',
        name: 'SaleCommissionTierConfig',
        component: 'SaleCommissionTierConfig'
      },
      {
        titleKey: 'staff',
        title: 'Nhân viên',
        name: 'StaffList',
        component: 'StaffList', 
        children: [
          { name: 'StaffDetail', title: 'Chi tiết nhân viên', component: 'StaffDetail' }
        ]
      },
      {
        titleKey: 'general_config',
        name: 'Configuration', 
        title: 'Cấu hình chung', 
        component: 'Configuration'
      },
      {
        titleKey: 'audit_log',
        title: 'Nhật ký thao tác',
        name: 'AuditLogList',
        component: 'AuditLogList'
      }
    ]
  },
  // {
  //   title: 'Lịch sử thanh toán',
  //   group: 'apps',
  //   icon: 'attach_money',
  //   name: 'PayHistoryList',
  //   roleId: 16
  // }
];
